'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValid = exports.validate = undefined;

var _string = require('./string');

Object.keys(_string).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _string[key];
        }
    });
});

var _util = require('./util');

Object.keys(_util).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _util[key];
        }
    });
});

var _boolean = require('./boolean');

Object.keys(_boolean).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _boolean[key];
        }
    });
});

var _number = require('./number');

Object.keys(_number).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _number[key];
        }
    });
});

var _date = require('./date');

Object.keys(_date).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _date[key];
        }
    });
});

var _creditCard = require('./creditCard');

Object.keys(_creditCard).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _creditCard[key];
        }
    });
});

var _ip = require('./ip');

Object.keys(_ip).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _ip[key];
        }
    });
});

var _isnil = require('./lib/isnil.js');

var _array = require('./lib/array.js');

var _reduce = require('./lib/reduce.js');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var validate = exports.validate = function validate() {
    for (var _len = arguments.length, fn = Array(_len), _key = 0; _key < _len; _key++) {
        fn[_key] = arguments[_key];
    }

    return function (value) {
        if ((0, _isnil.isNil)(value)) {
            return false;
        }

        return (0, _reduce.reduce)(function (acc, x) {
            if ((0, _isnil.isNil)(x)) {
                throw new Error('The function for validation is null or undefined.');
            } else {
                return acc && x(value);
            }
        }, true, fn);
    };
};

var isValid = exports.isValid = function isValid(v) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return validate.apply(undefined, _toConsumableArray((0, _array._isArray)(r) ? r : [r]))(v);
};